import styled from "styled-components";

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(${({lucroRealPresumido}) => lucroRealPresumido ? 4 : 'auto-fit'}, minmax(160px, 250px));
  grid-gap: 2rem;
  justify-content: center;

  @media screen and (max-width: 814px){
    ${({lucroRealPresumido}) => lucroRealPresumido && 'grid-template-columns: repeat(auto-fit, minmax(160px, 250px))'};
  }
  .react-card-flip {
    height: 100%;

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
  }
`;

export default { Container };
